module.exports = __webpack_public_path__ + "static/media/562.9a157365.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/562.png
// module id = 772
// module chunks = 0